import { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DefaultView from "../components/DefaultView";
import EmailLeftbar from "../components/EmailLeftbar";
import EmptyResult from "../components/EmptyResult";
import FaxHeaderTableRow from "../components/FaxHeaderTableRow";
import { actionGetReceivedMessages } from "../store/actions/inboxAction";
import { actionGetFaxHeader } from "../store/actions/settingAction";

const FaxHeaders = ({
  actionGetFaxHeader,
  user,
  faxHeaderData,
  faxHeaderloder,
}) => {
  useEffect(() => {
    actionGetFaxHeader();
  }, [actionGetFaxHeader]);
  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* start page title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 main_heading">Fax Header</h4>
              <div className="page-title-right">
                <DefaultView />
              </div>
            </div>
            {/* <div className="d-flex justify-content-end mb-3">
              <div className="btn-group float-end">
                <button
                  type="button"
                  className="btn btn-sm btn-success waves-effect"
                >
                  <i className="fa fa-chevron-left" />
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-success waves-effect"
                >
                  <i className="fa fa-chevron-right" />
                </button>
              </div>
            </div> */}
          </div>
        </div>
        {/* end page title */}
        <div className="row">
          <div className="col-12">
            {/* Left sidebar */}
            <EmailLeftbar />
            {/* End Left sidebar */}

            {/* Right Sidebar */}
            <div className="email-rightbar mb-3 compose-section">
              <div className="card">
                <div
                  className="btn-toolbar p-3 d-flex justify-content-between align-items-start"
                  role="toolbar"
                >
                  <div className="flex-grow-1">
                    <div className="mb-2">
                      <div className="fs-6 text-dark mb-1">Create and customize header templates for your outgoing fax transmissions.</div>
                      <div className="text-muted small">Design professional headers with company information, contact details, and branding for all your fax communications.</div>
                    </div>
                  </div>
                  <div className="ms-3">
                    <Link
                      to="/fax-headers/create"
                      className="btn btn-primary waves-light waves-effect"
                    >
                      <i className="fa fa-plus me-2" />   Add
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  {(
                    <div className="table-responsive">
                      <table className="table table-editable table-nowrap align-middle table-edits">
                        <thead>
                          <tr style={{ cursor: "pointer" }}>
                            <th>Header Name</th>
                            <th>Header Numbers</th>
                            <th>Company Address</th>
                            <th>Created At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {faxHeaderloder &&
                            [...Array(5)].map((_, i) => (
                              <tr key={i}>
                                <td>
                                  <div
                                    className="skeleton py-2"
                                    style={{ width: "80%" }}
                                  />
                                </td>
                                <td>
                                  <div
                                    className="skeleton"
                                    style={{ width: "60%" }}
                                  />
                                </td>
                                <td>
                                  <div
                                    className="skeleton"
                                    style={{ width: "70%" }}
                                  />
                                </td>
                                <td>
                                  <div
                                    className="skeleton"
                                    style={{ width: "40%" }}
                                  />
                                </td>
                                <td>
                                  <div
                                    className="skeleton"
                                    style={{ width: "50%" }}
                                  />
                                </td>
                              </tr>
                            ))}
                          {faxHeaderData &&
                            faxHeaderData.map((data, index) => (
                              <FaxHeaderTableRow
                                key={index}
                                id={data.header_ID}
                                name={data.header_text}
                                number={data.header_fromNumber}
                                address={data.company_address}
                                date={data.header_addTime}
                              />
                            ))}

                          {!faxHeaderloder &&
                            faxHeaderData &&
                            faxHeaderData.length == 0 && (
                              <tr>
                                <td colSpan={5}>
                                  <EmptyResult title={"No Fax Header Data Found"}
                                    description={`You currently have no fax headers. Click "Add" to create a new header.`} />
                                </td>
                              </tr>
                            )}
                        </tbody>
                      </table>
                    </div>
                  )}

                </div>
              </div>
              {/* card */}
            </div>
            {/* end  Right Sidebar Col-9 */}
          </div>
        </div>
      </div>
    </div >
  );
};
const mapStateToProps = (state) => {
  return {
    getReceivedMessagesLoader: state.inbox.getReceivedMessagesLoader,
    receivedMessages: state.inbox.receivedMessages,
    faxHeaderData: state.setting.faxHeaderData,
    faxHeaderloder: state.setting.faxHeaderloder,
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, {
  actionGetReceivedMessages,
  actionGetFaxHeader,
})(FaxHeaders);
